import { DestinoFormaPagamento } from 'src/tipos'

/**
 * Teto de parcelas de uma opção do restante, para qualquer forma de pagamento.
 * Espelha PlanoPagamentoNegociado.MaximoParcelas no backend, que é quem decide.
 * A entrada e a taxa de matrícula são sempre parcela única.
 */
export const MAXIMO_PARCELAS = 36

/** Mensagem de erro para a quantidade de parcelas informada, ou null se for válida. */
export const validarQuantidadeParcelas = (
  destino: string,
  quantidadeParcelas: number
): string | null => {
  if (!quantidadeParcelas || quantidadeParcelas < 1) {
    return 'A opção precisa de ao menos uma parcela.'
  }

  if (
    destino !== DestinoFormaPagamento.Entrada &&
    quantidadeParcelas > MAXIMO_PARCELAS
  ) {
    return `O máximo é de ${MAXIMO_PARCELAS} parcelas por opção.`
  }

  return null
}
